// extracted by mini-css-extract-plugin
export default {"JobworkCloseForm":"JobworkCloseForm_JobworkCloseForm__bCv+C"};